export default __webpack_public_path__ + "assets/656b84ecf638a3b3c8a2e7a24d965bf4/11.jpg";